import React from 'react'

import * as S from './styled'
import type { Props } from './types'

export const SideSummaryItem = ({ title, children }: Props) => {
  return (
    <S.Container>
      {title && <S.Title>{title}</S.Title>}
      {children && <S.Children>{children}</S.Children>}
    </S.Container>
  )
}
